/** Shared dynamic import loaders — use with createLazyComponent + preload on mount. */

export const loadSideMenu = () => import('~/components/organisms/SideMenu.vue')
export const loadQuotation = () => import('~/components/organisms/Quotation.vue')
export const loadLightBox = () => import('~/components/organisms/LightBox.vue')
export const loadProductSelectSide = () => import('~/components/organisms/ProductSelectSide.vue')
export const loadSupplementarySide = () => import('~/components/templates/SupplementarySide.vue')

export const loadProductCategory = () => import('~/components/pages/ProductCategory.vue')
export const loadCollection = () => import('~/components/pages/Collection.vue')
export const loadPage = () => import('~/components/pages/Page.vue')
export const loadTipsAndAdvice = () => import('~/components/pages/TipsAndAdvice.vue')
export const loadCity = () => import('~/components/pages/City.vue')

export const loadQueueFlow = () => import('~/components/plugins/FormsList/Includes/Flows/QueueFlow.vue')
export const loadClientAuthorizationFlow = () => import('~/components/plugins/FormsList/Includes/Flows/ClientAuthorizationFlow.vue')
export const loadClientForm = () => import('~/components/plugins/FormsList/Includes/Flows/ClientForm.vue')

export function loadPlugin(name) {
    return import(`~/components/plugins/${name}/${name}.vue`)
}

export function preloadChunk(loader, label) {
    if (!import.meta.client) {
        return Promise.resolve()
    }

    return loader().catch((error) => {
        console.warn(`[preload] ${label} chunk failed:`, error)
    })
}

export function preloadOnIdle(callback) {
    if (!import.meta.client) {
        return
    }

    const run = () => {
        const result = callback()
        if (result?.catch) {
            result.catch(() => {})
        }
    }

    if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 3000 })
    } else {
        setTimeout(run, 1500)
    }
}

export const preloadSideMenu = () => preloadChunk(loadSideMenu, 'SideMenu')
export const preloadQuotation = () => preloadChunk(loadQuotation, 'Quotation')
export const preloadLightBox = () => preloadChunk(loadLightBox, 'LightBox')
export const preloadProductSelectSide = () => preloadChunk(loadProductSelectSide, 'ProductSelectSide')
export const preloadSupplementarySide = () => preloadChunk(loadSupplementarySide, 'SupplementarySide')

/**
 * Preload the page shell chunk for [...slug] routes (category, CMS page, etc.).
 */
export function preloadSlugPageComponent(name, pageType) {
    if (pageType === 'Tips And Advices') {
        return preloadChunk(loadTipsAndAdvice, 'TipsAndAdvice')
    }

    switch (name) {
        case 'product-category':
            return preloadChunk(loadProductCategory, 'ProductCategory')
        case 'collection':
            return preloadChunk(loadCollection, 'Collection')
        case 'page':
            return preloadChunk(loadPage, 'Page')
        case 'city':
            return preloadChunk(loadCity, 'City')
        default:
            return Promise.resolve()
    }
}

/** PDP: gallery lightbox + variant side panel. */
export function preloadProductPageChunks({ hasSelects = false } = {}) {
    preloadLightBox()
    if (hasSelects) {
        preloadProductSelectSide()
    }
}

export function preloadPlugin(name) {
    if (!name) {
        return Promise.resolve()
    }

    return preloadChunk(() => loadPlugin(name), `plugin:${name}`)
}
